export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_07.04d2196c.jpg";